import { render, staticRenderFns } from "./TransactionPrice.vue?vue&type=template&id=3f12c893&scoped=true&"
import script from "./TransactionPrice.vue?vue&type=script&lang=js&"
export * from "./TransactionPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f12c893",
  null
  
)

export default component.exports